<template>
  <div class="user-layout">
    <Header />

    <!-- 顶部装饰 Banner -->
    <div class="user-banner">
      <img src="@/assets/images/user-banner-bg.jpg" alt="banner" />
    </div>

    <!-- 主体内容区域 -->
    <div class="user-main">
      <div class="user-container">
        <!-- 面包屑导航 -->
        <div class="breadcrumb">
          <router-link to="/" class="home-icon">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="currentColor">
              <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
            </svg>
          </router-link>
          <router-link to="/">首页</router-link>
          <span class="separator">/</span>
          <span class="current">会员中心</span>
        </div>

        <!-- 内容区域 -->
        <div class="user-content">
          <!-- 左侧菜单 -->
          <div class="user-sidebar">
            <div class="sidebar-title">会员中心</div>
            <ul class="sidebar-menu">
              <li v-for="(item, index) in menuList" :key="index">
                <router-link v-if="item.url" :to="item.url" :class="{ active: isActive(item.url) }">
                  {{ item.name }}
                  <span class="arrow">›</span>
                </router-link>
                <a v-else href="javascript:;" @click="handleMenuClick(item.action)">
                  {{ item.name }}
                  <span class="arrow">›</span>
                </a>
              </li>
            </ul>
          </div>

          <!-- 右侧内容 -->
          <div class="user-body">
            <router-view />
          </div>
        </div>
      </div>
    </div>

    <Footer :auth="false" />
  </div>
</template>

<script>
import Header from "@/layout/components/header";
import Footer from "@/layout/components/footer";
import { mapState } from "vuex";
import user from "@/api/user";

export default {
  name: 'UserLayout',
  components: { Header, Footer },
  computed: {
    ...mapState(['account'])
  },
  data() {
    return {
      menuList: [
        { name: '会员主页', url: '/user/home' },
        { name: '协会课程', url: '/course/list' },
        { name: '我的课程订单', url: '/course/my-orders' },
        // { name: '我的关注', url: '/user/focus' },
        // { name: '我的收藏', url: '/user/folder' },
        { name: '投诉建议', url: '/complaint/submit' },
        { name: '我的资料', url: '/user/account-info' },
        { name: '我的证书', url: '/user/my-certificate' },
        { name: '退出登录', url: '', action: 'logout' }
      ]
    }
  },
  methods: {
    // 判断当前路由是否激活
    isActive(url) {
      return this.$route.path === url || this.$route.path.startsWith(url + '/');
    },
    // 处理菜单点击
    handleMenuClick(action) {
      if (action === 'logout') {
        this.logout();
      }
    },
    // 退出登录
    logout() {
      user.logout({
        ident: 'logout'
      }).then(res => {
        if (res) {
          this.$store.dispatch('auth/logout');
          this.$message.success(res.msg || '退出成功');
          this.$router.push('/');
        }
      }).catch(() => {
        this.$store.dispatch('auth/logout');
        this.$message.success('退出成功');
        this.$router.push('/');
      });
    }
  }
}
</script>

<style lang="scss" scoped>
.user-layout {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f5f7fa;
}

/* 顶部装饰 Banner */
.user-banner {
  width: 100%;
  height: 180px;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
}

/* 主体内容区域 */
.user-main {
  flex: 1;
  padding: 0 0 60px;
}

.user-container {
  max-width: 1200px;
  margin: -83px auto 0;
  padding: 0 20px;
  box-sizing: border-box;
  position: relative;
  z-index: 1;
}

/* 面包屑导航 */
.breadcrumb {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  font-size: 14px;
  background-color: #eaf7fa;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  .home-icon {
    display: flex;
    align-items: center;
    margin-right: 8px;
    color: #4facfe;
    text-decoration: none;

    &:hover {
      color: #00f2fe;
    }
  }

  a {
    color: #666;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #4facfe;
    }
  }

  .separator {
    margin: 0 8px;
    color: #999;
  }

  .current {
    color: #666;
  }
}

/* 内容区域 */
.user-content {
  display: flex;
}

/* 左侧菜单 */
.user-sidebar {
  width: 240px;
  flex-shrink: 0;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  height: fit-content;

  .sidebar-title {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    padding: 20px 24px;
    text-align: left;
    border-radius: 8px 8px 0 0;
  }

  .sidebar-menu {
    list-style: none;
    margin: 0;
    padding: 0;

    li {
      border-bottom: 1px solid #f0f0f0;

      &:last-child {
        border-bottom: none;
      }

      a {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 24px;
        color: #333;
        font-size: 15px;
        text-decoration: none;
        transition: all 0.3s ease;
        background-color: #fff;

        &:hover {
          background-color: #f8f9fa;
          color: #4facfe;

          .arrow {
            color: #4facfe;
          }
        }

        &.active {
          background-color: #f0f8ff;
          color: #4facfe;
          font-weight: 500;

          .arrow {
            color: #4facfe;
          }
        }

        .arrow {
          color: #999;
          font-size: 18px;
          transition: color 0.3s ease;
        }
      }
    }
  }
}

/* 右侧内容 */
.user-body {
  flex: 1;
  min-height: 400px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  overflow: hidden;
}

/* 响应式 */
@media screen and (max-width: 1240px) {
  .user-container {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .user-content {
    flex-direction: column;
  }

  .user-sidebar {
    width: 100%;
  }

  .user-banner {
    height: 120px;
  }

  .user-container {
    margin-top: -60px;
  }
}
</style>
